import { Flex, Icon, Menu, Text } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';
import React from 'react';
import { PROPERTY_SELECTOR_DESKTOP_ADD_ROW_INSET } from './propertySelectorSections.ts';

interface PropertySelectorGroupDesktopProps {
	onAddProperty: () => void;
	disabled?: boolean;
	loading?: boolean;
}

/**
 * Desktop-only component for adding a new property in the PropertySelector menu
 * Displays as a Menu.ItemGroup with "Add new property" option
 * Only works inside Menu context (not for mobile Drawer)
 */
const PropertySelectorGroupAdd: React.FC<PropertySelectorGroupDesktopProps> = ({
	onAddProperty,
	disabled = false,
	loading = false,
}) => {
	return (
		<Menu.ItemGroup>
			<Menu.Item
				px={PROPERTY_SELECTOR_DESKTOP_ADD_ROW_INSET}
				py={2}
				borderRadius={'full'}
				value="add-property"
				cursor={disabled ? 'default' : 'pointer'}
				onClick={onAddProperty}
				disabled={disabled || loading}
				fontWeight="medium"
				_hover={{ bg: 'surface.subtle' }}
			>
				<Flex align="center" p={0}>
					<Icon as={FiPlus} boxSize={6} mr={2} />
					<Text fontSize="lg">Add new property</Text>
				</Flex>
			</Menu.Item>
		</Menu.ItemGroup>
	);
};

export default PropertySelectorGroupAdd;
